import { useDesignMaxTheme } from "@/packages";
import { type SpecialType } from "@/shared/server";
import { FONT } from "@/styles";
import { Box, Center, Flex, Text } from "@chakra-ui/react";
import DOMPurify from "dompurify";

export const SpecialDetail = ({ special }: { special: SpecialType }) => {
    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile, isTablet, isLaptop } = MEDIAS();
    const { special_idx, special_name, content, title, imgList } = { ...special };
    return (
        <Center key={special_idx} position="relative" w="100%">
            <Center as="section">
                <Flex
                    position="relative"
                    p={isMobile ? "0 20px" : "0"}
                    flexDir={isMobile ? "column-reverse" : "row"}
                    gap={isMobile ? "24px" : "80px"}
                >
                    <Box
                        zIndex="1"
                        position="relative"
                        maxW="680px !important"
                        w="100%"
                        h={isMobile ? "224px" : "800px"}
                        bg={imgList[0] ? `url(${imgList[0].img_URL})no-repeat center/cover` : "gray.100"}
                    />

                    <Flex
                        zIndex="1"
                        flex="1"
                        h={isTablet ? "auto" : "1168px"}
                        flexDir="column"
                        justifyContent="space-between"
                        alignItems="flex-end"
                    >
                        <Flex w="100%" flexDir="column" gap="32px">
                            <Flex flexDir="column" gap={isMobile ? "16px" : "24px"}>
                                <Text {...FONT("cormorant", isMobile ? 32 : 56, 700, 1.2)}>SPECIAL</Text>
                                <Text
                                    {...FONT("pretendard", isMobile ? 12 : 18, 300, 1.4)}
                                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(title.kor) }}
                                />
                            </Flex>
                            <Flex gap="40px">
                                {!isMobile && <Box w="2px" bg="#6b6b6b" />}
                                <Flex flexDir="column" pr="20px" gap={isMobile ? "16px" : "24px"}>
                                    <Text {...FONT("notoSerif", isMobile ? 16 : 32, 400, 1.4)}>{special_name.kor}</Text>
                                    <Text
                                        {...FONT("pretendard", isMobile ? 12 : 18, 300, 1.4)}
                                        dangerouslySetInnerHTML={{
                                            __html: DOMPurify.sanitize(content.kor),
                                        }}
                                    />
                                </Flex>
                            </Flex>
                        </Flex>
                        {!isLaptop && (
                            <Box
                                maxW="720px"
                                w="100%"
                                h="538px"
                                bg={imgList[1] ? `url(${imgList[1].img_URL})no-repeat center/cover` : "gray.100"}
                            />
                        )}
                    </Flex>
                    {!isLaptop && (
                        <Box
                            zIndex="0"
                            position="absolute"
                            left="50%"
                            bottom="108px"
                            w="656px"
                            h="496px"
                            transform="translateX(-50%)"
                            bg="#3b6c8d"
                        />
                    )}
                </Flex>
            </Center>
        </Center>
    );
};
